/**
 * Field Renderer Component
 * A reusable component for rendering read-only field data in grid layout
 */
import React from 'react'
import { Grid2 as Grid, Typography, Box, TypographyProps } from '@mui/material'

export interface FieldConfig {
  name: string
  label: string
  formatter?: (value: any, data: Record<string, any>) => React.ReactNode
  gridSize?: number
}

export interface FieldRendererProps {
  fields: FieldConfig[]
  data: Record<string, any>
  spacing?: number
  gridSize?: number
}

const FieldRenderer: React.FC<FieldRendererProps> = ({
  fields,
  data,
  spacing = 1,
  gridSize = 6
}) => {
  return (
    <Grid container spacing={spacing} sx={{ p: 0, m: 0 }}>
      {fields.map(field => {
        const value = field.formatter
          ? field.formatter(data[field.name], data)
          : data[field.name] !== undefined && data[field.name] !== null
            ? data[field.name]
            : '-'

        return (
          <Grid
            key={field.name}
            size={field.gridSize ? field.gridSize : gridSize}>
            <Box sx={{ p: 0.5, display: 'flex', flexDirection: 'column' }}>
              <Typography variant={'body5' as TypographyProps['variant']}>
                {field.label}
              </Typography>
              <Typography variant={'body3' as TypographyProps['variant']}>
                {value}
              </Typography>
            </Box>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default FieldRenderer
